import ApiKey from './ApiKey'
import type { ApiKeyProps } from './ApiKey'

export type { ApiKeyProps }
export default ApiKey
